import { PipeTransform } from '@angular/core';
import * as moment from "moment";
/** Parse PHP JSON `date` field without `Date(string)` (WebKit treats unzoned ISO as UTC). */
export function localDateFromPhpDateField(dateStr) {
    if (typeof dateStr !== 'string') {
        return null;
    }
    var m = dateStr.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2}):(\d{2})(?:\.(\d+))?/);
    if (!m) {
        return null;
    }
    return new Date(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +m[6]);
}
var isoInstantRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?([+-]\d{2}:?\d{2}|Z)$/;
/** Symfony JsonSerializable DateTime `{ date, timezone }` — respect UTC vs local wall (see timeline-date pipe). */
export function dateFromPhpDateTimeObject(value) {
    if (!value || typeof value.date !== 'string') {
        return null;
    }
    var dateStr = value.date;
    var normalized = dateStr.indexOf(' ') !== -1 ? dateStr.replace(' ', 'T') : dateStr;
    if (isoInstantRegex.test(normalized)) {
        var d = new Date(normalized);
        return isNaN(d.getTime()) ? null : d;
    }
    var asUtcZ = normalized.replace(/\.\d+$/, '') + 'Z';
    var phpTz = value.timezone != null ? String(value.timezone) : '';
    var u = phpTz.toUpperCase();
    var isPhpUtc = u === 'UTC' || u === 'ETC/UTC' || u === 'ETC/GMT';
    if (isPhpUtc && isoInstantRegex.test(asUtcZ)) {
        var d = new Date(asUtcZ);
        return isNaN(d.getTime()) ? null : d;
    }
    return localDateFromPhpDateField(dateStr);
}
var TimePipe = /** @class */ (function () {
    function TimePipe(settings) {
        this.settings = settings;
        this.format = '';
    }
    TimePipe.prototype.transform = function (value, args) {
        if (value == '' || value == null) {
            return '';
        }
        var language = this.settings._csLanguage;
        if (language == 'en') {
            language = 'en-GB';
        }
        moment.locale(language);
        var intlSettings = this.settings._csIntlSettings;
        if (intlSettings['time'] == 1) {
            this.format = 'HH:mm';
        }
        else {
            this.format = 'hh:mm a';
        }
        var momentInput;
        if (value instanceof Date) {
            momentInput = value;
        }
        else if (value && typeof value === 'object' && value.hasOwnProperty('date')) {
            var parsed = dateFromPhpDateTimeObject(value);
            if (!parsed) {
                return '';
            }
            momentInput = parsed;
        }
        else {
            var valStr = typeof value === 'string' ? value : String(value);
            var isoRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?([+-]\d{2}:?\d{2}|Z)$/;
            var utcTimeString = (isoRegex.test(valStr)) ? new Date(valStr) : new Date(valStr + ' UTC');
            utcTimeString = new Date(utcTimeString.toLocaleString(this.settings._csLanguage, { timeZone: this.settings._csCountryCode.timezone }));
            momentInput = utcTimeString;
        }
        return moment(momentInput).format(this.format);
    };
    return TimePipe;
}());
export { TimePipe };
